import {
  AutoCompleteTailwindThemes,
  AvatarTailwindThemes,
  BadgeTailwindThemes,
  ButtonTailwindThemes,
  CalendarTailwindThemes,
  CardTailwindThemes,
  CheckboxTailwindThemes,
  ChipsTailwindThemes,
  ChipTailwindThemes,
  ContextMenuTailwindThemes,
  DialogTailwindThemes,
  DropdownTailwindThemes,
  IconFieldTailwindThemes,
  InputIconTailwindThemes,
  InputMaskTailwindThemes,
  InputNumberTailwindThemes,
  InputSwitchTailwindThemes,
  InputTextareaTailwindThemes,
  InputTextTailwindThemes,
  MenuTailwindThemes,
  MultiSelectTailwindThemes,
  ProgressSpinnerTailwindThemes,
  RadioButtonTailwindThemes,
  SidebarTailwindThemes,
  SkeletonTailwindThemes,
  TabViewTailwindThemes,
  ToastTailwindThemes,
  TooltipTailwindThemes,
  TreeTailwindThemes,
} from '@repo/atomic-components';

export const PrimeReactTailwindThemes = {
  ...AutoCompleteTailwindThemes,
  ...AvatarTailwindThemes,
  ...BadgeTailwindThemes,
  ...ButtonTailwindThemes,
  ...CalendarTailwindThemes,
  ...CardTailwindThemes,
  ...CheckboxTailwindThemes,
  ...ChipsTailwindThemes,
  ...ChipTailwindThemes,
  ...ContextMenuTailwindThemes,
  ...DialogTailwindThemes,
  ...DropdownTailwindThemes,
  ...IconFieldTailwindThemes,
  ...InputIconTailwindThemes,
  ...InputMaskTailwindThemes,
  ...InputNumberTailwindThemes,
  ...InputSwitchTailwindThemes,
  ...InputTextareaTailwindThemes,
  ...InputTextTailwindThemes,
  ...MenuTailwindThemes,
  ...MultiSelectTailwindThemes,
  ...ProgressSpinnerTailwindThemes,
  ...RadioButtonTailwindThemes,
  ...SidebarTailwindThemes,
  sidebar: {
    ...SidebarTailwindThemes?.sidebar,
    mask: { className: 'flex pointer-events-auto bg-black/60 transition duration-200' },
  },
  ...SkeletonTailwindThemes,
  ...TabViewTailwindThemes,
  ...ToastTailwindThemes,
  ...TooltipTailwindThemes,
  ...TreeTailwindThemes,
};
